<template>
	<v-expansion-panels
		:accordion="accordion"
		:dark="dark"
		:disabled="disabled"
		flat
		:focusable="focusable"
		:hover="focusable"
		:inset="inset"
		:light="light"
		:mandatory="mandatory"
		:max="max"
		:multiple="multiple"
		:popout="popout"
		:readonly="readonly"
		tile
		:value="selected"
		v-on="$listeners"
	>
		<slot></slot>
	</v-expansion-panels>
</template>

<script>
export default {
	props: {
		accordion: Boolean,
		dark: Boolean,
		disabled: Boolean,
		focusable: Boolean,
		hover: Boolean,
		inset: Boolean,
		light: Boolean,
		mandatory: Boolean,
		max: [Number, String],
		multiple: Boolean,
		popout: Boolean,
		readonly: Boolean,
		value: null,
	},
	computed: {
		selected() {
			return this.value
		},
	},
}
</script>
